import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from 'react-router-dom'
import logo from '../../assets/lesaLogo.png'
import { SvgIcon, SvgType } from '../../common/svgIcon/SvgIcon'
import routes from '../../routes'
import { loggedOut } from '../../slices/authSlice'
import RouteLink from './RouteLink'
import { NavBar } from './styled'

const Navbar = () => {
  const { currentUser } = useSelector((state: any) => state.auth)
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [openMobileNav, setOpenMobileNav] = useState(false)

  const handleClick = () => {
    setOpenMobileNav(!openMobileNav)
  }

  const handleLogout = async () => {
    localStorage.removeItem('jwt_token')
    await dispatch(loggedOut)
    navigate(routes.login)
  }

  const closeMobileNav = () => {
    setOpenMobileNav(false)
  }

  return (
    <NavBar>
      <Link to={routes.root} id="logoLink">
        <img src={logo} className="logo d-block" alt="logo" />
      </Link>
      <div className="session-links">
        {currentUser && (
          <>
            <RouteLink route={routes.liveSessions}>Live Sessions</RouteLink>
            <RouteLink route={routes.onDemandSessions}>On-Demand</RouteLink>
            <RouteLink route={routes.networking}>Networking</RouteLink>
          </>
        )}
      </div>
      {currentUser ? (
        <>
          <div className="user-links">
            <>
              <RouteLink route={routes.profile}>
                <span>
                  <SvgIcon type={SvgType.PROFILE} />
                </span>
                <span className="link-text">Profile</span>
              </RouteLink>

              <Link onClick={handleLogout} to="">
                <span>
                  <SvgIcon type={SvgType.LOGOUT} />
                </span>
                <span className="link-text">Logout</span>
              </Link>
            </>
          </div>
          <div onClick={handleClick} className="mobile-nav">
            <span className={openMobileNav ? 'show-menu' : 'hide-menu'}>
              <SvgIcon type={SvgType.MOBILEBURGER} fill="black" />
            </span>
          </div>
          <div
            id={openMobileNav ? 'open-mobile-nav' : 'close-mobile-nav'}
            className="mobile-user-links"
          >
            <RouteLink route={routes.profile}>
              <span>
                <SvgIcon type={SvgType.PROFILE} />
              </span>
              <span className="link-text" onClick={closeMobileNav}>
                Profile
              </span>
            </RouteLink>

            <RouteLink route={routes.liveSessions}>
              <span onClick={closeMobileNav}>Live Sessions</span>
            </RouteLink>
            <RouteLink route={routes.onDemandSessions}>
              <span onClick={closeMobileNav}>On-Demand</span>
            </RouteLink>

            <Link onClick={handleLogout} to="">
              <span>
                <SvgIcon type={SvgType.LOGOUT} />
              </span>
              <span className="link-text" onClick={closeMobileNav}>
                Logout
              </span>
            </Link>
          </div>
        </>
      ) : (
        <div className="user-links" style={{ justifySelf: 'flex-end' }}>
          <Link to={routes.login}>
            <span>
              <SvgIcon type={SvgType.LOGIN} />
            </span>
            <span className="link-text">Login</span>
          </Link>
        </div>
      )}
    </NavBar>
  )
}

export default Navbar
